import styled, { css } from 'styled-components'
import { fanta } from '@chegg/fanta'
import { publicAssetUrl } from '@chegg-wt/core/utils/url'
import { spacing, colors, font } from '@chegg-ui/theme'

export const Container = styled.div.attrs({
  role: 'region',
  'aria-label': 'Search Results',
})<{ isOverflow: boolean }>`
  margin-top: ${fanta.spacing.lg};
  ${({ isOverflow }) => {
    if (isOverflow) {
      return css`
        height: 100vh;
        padding-bottom: 280px;
        overflow: scroll;
      `
    }
  }}
`

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 285px;
  margin: 73px auto 0;
`

export const EmptyContainer = styled(LoadingContainer)`
  width: 344px;
  margin: 0 auto;
  padding-bottom: ${spacing.px24};
`

export const ErrorContainer = styled(EmptyContainer)`
  margin: 73px auto 0;
`

export const EmptyImage = styled.div`
  background: ${`url('${publicAssetUrl('search-result-empty.png')}') top center
    no-repeat;`};
  width: 100%;
  height: 200px;
  height: 344px;
  background-size: contain;
`

export const EmptyCitationsImage = styled.div`
  background: ${`url('${publicAssetUrl('empty-bookmarks.png')}') top center no-repeat;`};
  width: 100%;
  height: 200px;
  background-size: contain;
`

export const LoadingDescription = styled.div`
  display: inline-block;
  width: 100%;
  max-width: 420px;
  margin-bottom: ${fanta.spacing.md};
  text-align: center;
`

export const Heading = styled.h2`
  margin-top: 20px;
  margin-bottom: 10px;
  font-size: ${fanta.font.size.sm};
  font-weight: ${fanta.font.weight.bold};
  color: ${colors.dark};
`

export const Body = styled.p`
  font-size: ${font.size.px14};
  line-height: 145%;
  margin: 0 0 10px;
  font-weight: ${font.weight.bold};
  color: ${colors.dark};
`

export const NoResultBody = styled.p`
  font-size: ${font.size.px14};
  line-height: 145%;
  margin: 0 0 10px;
  color: ${colors.dark};
`

export const ResultsTextContainer = styled.div`
  margin-top: ${fanta.spacing.md};
  margin-bottom: ${fanta.spacing.xs};
  margin-left: ${fanta.spacing.xxs};
  font-size: ${fanta.font.size.xs};
`

export const ResultText = styled.span`
  font-weight: bold;
`

export const LinkText = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: ${colors.link};
  text-decoration: none;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 18px;
  &:hover {
    text-decoration: underline;
  }
`
